module.exports = __webpack_public_path__ + "public/images/shedule-kr-table.0883c4416b98c55e857250ef328245e3.png";